export default __webpack_public_path__ + "static/media/RemiderIconGrey.25cf7875.svg";